import { Dayjs } from 'dayjs'

import { DATE_TEMPLATES, format } from '~/astra'
import { Location } from '~/storm'

export type ServicePeriod = NonNullable<Location['service_periods']>[number]

export const workingWeekdays = ['1', '2', '3', '4', '5'] // isoWeekday, Mon–Fri

export function findServicePeriod({ date, location }: { date: Dayjs; location: Pick<Location, 'service_periods'> }): ServicePeriod | undefined {
    const formattedDate = format(date, DATE_TEMPLATES.iso)
    const weekDay = date.isoWeekday().toString()

    return location.service_periods?.find(servicePeriod => {
        // Finding the first valid service period, as we may assume that
        // the service periods are sorted by start_date
        if (servicePeriod.end_date && servicePeriod.end_date < formattedDate) {
            return false
        }

        if (servicePeriod.start_date && servicePeriod.start_date > formattedDate) {
            return false
        }

        return servicePeriod.days_of_week.includes(weekDay)
    })
}

// A closure can be split across several is_closed periods sharing the same date range
// but different weekday groups (e.g. Mon–Wed and Thu–Fri with different opening hours).
// Union their weekdays so callers see the full picture, not just the resolved period.
export function getClosedWeekdaysInSameRange(servicePeriod: ServicePeriod, servicePeriods: ServicePeriod[]): string[] {
    const closedDays = new Set(
        servicePeriods
            .filter(period => period.is_closed && period.start_date === servicePeriod.start_date && period.end_date === servicePeriod.end_date)
            .flatMap(period => period.days_of_week)
    )
    return workingWeekdays.filter(dayOfWeek => closedDays.has(dayOfWeek))
}
